import { useState, useRef, useEffect } from "react";
import "./Demo.scss";
import ActionBar from "../../components/ActionBar/ActionBar";
import ActionBarButton from "../../components/ActionBar/ActionBarButton";
import "../../components/ActionBar/ActionBarButton.scss";
import "../../components/ActionBar/ActionBar.scss";
import Modal from "../../components/Modal/Modal";
import RightSideBar from "../../components/RightSideBar/RightSideBar";
import Spinner from "../../components/Spinner/Spinner";
import ModalContent1 from "../../components/ModalContent/ModalContent1";
import ModalContent2 from "../../components/ModalContent/ModalContent2";
import ToolTip from "../../components/ToolTip/ToolTip";
import RightSideBarContent1 from "../../components/RightSideBarContent/RightSideBarContent1";
import RightSideBarContent2 from "../../components/RightSideBarContent/RightSideBarContent2";
import {
  Hurricane02,
  Circle,
  AlignLeft01,
  AlignRight01,
} from "@untitled-ui/icons-react";
import { useNavigate } from "react-router-dom";
import FlowButton from "../../components/FlowButton/FlowButton";
import FlowTextInput from "../../components/FlowTextInput/FlowTextInput";
import FlowCheckbox from "../../components/FlowCheckbox/FlowCheckbox";
import { normalizeColor } from "../../utils/colors";

function Demo() {
  const modalRef = useRef();
  const toolTipRef = useRef();
  const navigate = useNavigate();

  const [isSpinnerVisible, setSpinnerVisible] = useState(false);
  const [isRightSideBarVisible, setRightSideBarVisible] = useState(false);
  const [rightSideBarContent, setRightSideBarContent] = useState(null);
  const [paletteColor, setPaletteColor] = useState("#4576b4"); // Default blue
  const [showPalettePicker, setShowPalettePicker] = useState(false);

  const showSpinner = () => setSpinnerVisible(true);
  const hideSpinner = () => setSpinnerVisible(false);

  const showRightSideBar = (content) => {
    setRightSideBarContent(content);
    setRightSideBarVisible(true);
  };
  const hideRightSideBar = () => setRightSideBarVisible(false);

  const openModal = (e, arrow, content) => {
    const triggerElement = e.currentTarget;

    if (modalRef.current) {
      modalRef.current.open({
        arrow,
        content,
        triggerElement,
      });
    }
  };

  const showToolTip = (e, arrow, content) => {
    const triggerElement = e.currentTarget;

    if (toolTipRef.current) {
      toolTipRef.current.open({
        arrow,
        content,
        triggerElement,
      });
    }
  };

  // Starte docker lokalt: docker-compose up --build
  const pingPong = () => {
    fetch("http://backend:5001/ping") // backend is the service name
      .then((res) => res.text())
      .then(setResponse)
      .catch(console.error);
  };
  const [response, setResponse] = useState(null);

  return (
    <div className="demo-wrapper">
      <Modal ref={modalRef}></Modal>
      <ToolTip ref={toolTipRef}></ToolTip>

      <ActionBar>
        <ActionBarButton
          buttonText="Show Spinner"
          icon={<Hurricane02 width={18} height={18} color="white" />}
          onClick={showSpinner}
        />
        <div className="action-bar-spacer" />
        <ActionBarButton
          buttonText="Hide Spinner"
          icon={<Circle width={18} height={18} color="white" />}
          onClick={hideSpinner}
        />
        <div className="action-bar-spacer" />
        <ActionBarButton
          buttonText="Show Right"
          icon={<AlignLeft01 width={18} height={18} color="white" />}
          onClick={() => showRightSideBar(<RightSideBarContent2 />)}
        />
        <div className="action-bar-spacer" />
        <ActionBarButton
          buttonText="Hide Right"
          icon={<AlignRight01 width={18} height={18} color="white" />}
          onClick={hideRightSideBar}
        />
      </ActionBar>

      <div className="demo">
        {isSpinnerVisible && <Spinner text="... just testing the text" />}
        <RightSideBar
          isVisible={isRightSideBarVisible}
          content={rightSideBarContent}
        />

        <div className="demo-content">
          <p>Components display:</p>
          <div style={{ marginTop: "20px", marginBottom: "30px" }}>
            <p style={{ marginBottom: "10px", fontWeight: "600" }}>
              FlowButton Examples:
            </p>
            <table
              style={{ borderCollapse: "separate", borderSpacing: "10px 15px" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Default button (gray):
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      variant="default"
                    >
                      Cancel
                    </FlowButton>
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Default with icon:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      variant="default"
                      icon="close"
                    >
                      Close
                    </FlowButton>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Update button (blue):
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      variant="update"
                    >
                      Update
                    </FlowButton>
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Update with icon:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      variant="update"
                      icon="check"
                    >
                      Save Changes
                    </FlowButton>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Disabled button:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton variant="update" disabled>
                      Disabled
                    </FlowButton>
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Danger button (red):
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      variant="danger"
                    >
                      Delete
                    </FlowButton>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Danger with icon:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      variant="danger"
                      icon="delete"
                    >
                      Remove
                    </FlowButton>
                  </td>
                  <td colSpan="2"></td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Palette button:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowButton
                      palette
                      paletteColor={normalizeColor(paletteColor)}
                      icon="palette"
                      showChevron
                      isExpanded={showPalettePicker}
                      onClick={() => {
                        setShowPalettePicker(!showPalettePicker);
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "20px", marginBottom: "30px" }}>
            <p style={{ marginBottom: "10px", fontWeight: "600" }}>
              FlowCheckbox Examples:
            </p>
            <table
              style={{ borderCollapse: "separate", borderSpacing: "10px 15px" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Unchecked:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowCheckbox
                      checked={false}
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Checked:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowCheckbox
                      checked={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    With label:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowCheckbox
                      checked={false}
                      label="Accept terms"
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Disabled:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowCheckbox checked={true} disabled />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "20px", marginBottom: "30px" }}>
            <p style={{ marginBottom: "10px", fontWeight: "600" }}>
              FlowTextInput Examples:
            </p>
            <table
              style={{ borderCollapse: "separate", borderSpacing: "10px 15px" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Expandable with search icon:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowTextInput
                      placeholder="Search..."
                      expandable={true}
                      icon="search"
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Non-expandable with search:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowTextInput
                      placeholder="Search..."
                      expandable={false}
                      icon="search"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Expandable with filter icon:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowTextInput
                      placeholder="Filter..."
                      expandable={true}
                      icon="filter_list"
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      paddingLeft: "40px",
                      paddingRight: "20px",
                      verticalAlign: "middle",
                    }}
                  >
                    Non-expandable with person:
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <FlowTextInput
                      placeholder="Find person..."
                      expandable={false}
                      icon="person"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>Node Testing (Test01)</p>
          <button style={{ width: "120px", margin: "5px", padding: "5px" }}>
            Ping
          </button>
          <p>Modal</p>
          <div className="modal-buttons">
            <table className="modal-demo">
              <tbody>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(
                          e,
                          "top-left",
                          <ModalContent1></ModalContent1>
                        )
                      }
                    >
                      Top Left
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) => openModal(e, "top-center", "Top Center")}
                    >
                      Top Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "top-right", <ModalContent2 />)
                      }
                    >
                      Top Right
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "auto-top-left", "Auto Top Left (flips)")
                      }
                    >
                      Auto Top Left
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(
                          e,
                          "auto-top-center",
                          "Auto Top Center (flips)"
                        )
                      }
                    >
                      Auto Top Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "auto-top-right", "Auto Top Right (flips)")
                      }
                    >
                      Auto Top Right
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) => openModal(e, "left-top", "Left Top")}
                    >
                      Left Top
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "left-center", "Left Center")
                      }
                    >
                      Left Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "left-bottom", "Left Bottom")
                      }
                    >
                      Left Bottom
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) => openModal(e, "right-top", "Right Top")}
                    >
                      Right Top
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "right-center", "Right Center")
                      }
                    >
                      Right Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "right-bottom", "Right Bottom")
                      }
                    >
                      Right Bottom
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "bottom-left", "Bottom Left")
                      }
                    >
                      Bottom Left
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "bottom-center", "Bottom Center")
                      }
                    >
                      Bottom Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "bottom-right", "Bottom Right")
                      }
                    >
                      Bottom Right
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(
                          e,
                          "auto-bottom-left",
                          "Auto Bottom Left (flips)"
                        )
                      }
                    >
                      Auto Bottom Left
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(
                          e,
                          "auto-bottom-center",
                          "Auto Bottom Center (flips)"
                        )
                      }
                    >
                      Auto Bottom Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(
                          e,
                          "auto-bottom-right",
                          "Auto Bottom Right (flips)"
                        )
                      }
                    >
                      Auto Bottom Right
                    </button>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onClick={(e) =>
                        openModal(e, "no-arrow", <ModalContent2 />)
                      }
                    >
                      CENTER!
                    </button>
                  </td>
                </tr>

                {/* Add more buttons here as needed */}
              </tbody>
            </table>
          </div>
          <p>ToolTip</p>
          <div className="modal-buttons">
            <table className="modal-demo">
              <tbody>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "top-left", "Yo Mama!")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Top Left
                    </button>
                  </td>
                  <td>
                    <button
                      style={{
                        width: "120px",
                        margin: "5px",
                        padding: "5px",
                        backgroundColor: "#555555",
                      }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "top-center", "Top Center")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Top Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "top-right", <ModalContent2 />)
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Top Right
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "left-top", "Left Top")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Left Top
                    </button>
                  </td>
                  <td>
                    <button
                      style={{
                        width: "120px",
                        margin: "5px",
                        padding: "5px",
                        backgroundColor: "#555555",
                      }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "left-center", "Left Center")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Left Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "left-bottom", "Left Bottom")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Left Bottom
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "right-top", "Right Top")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Right Top
                    </button>
                  </td>
                  <td>
                    <button
                      style={{
                        width: "120px",
                        margin: "5px",
                        padding: "5px",
                        backgroundColor: "#555555",
                      }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "right-center", "Right Center")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Right Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "right-bottom", "Right Bottom")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Right Bottom
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "bottom-left", "Bottom Left")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Bottom Left
                    </button>
                  </td>
                  <td>
                    <button
                      style={{
                        width: "120px",
                        margin: "5px",
                        padding: "5px",
                        backgroundColor: "#555555",
                      }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "bottom-center", "Bottom Center")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Bottom Center
                    </button>
                  </td>
                  <td>
                    <button
                      style={{ width: "120px", margin: "5px", padding: "5px" }}
                      onMouseEnter={(e) =>
                        showToolTip(e, "bottom-right", "Bottom Right")
                      }
                      onMouseLeave={(e) => {
                        toolTipRef.current.close();
                      }}
                    >
                      Bottom Right
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>RightSideBar</p>
          <div className="modal-buttons">
            <button
              style={{ width: "120px", margin: "5px", padding: "5px" }}
              onClick={() => showRightSideBar(<RightSideBarContent1 />)}
            >
              Content 1
            </button>
            <button
              style={{ width: "120px", margin: "5px", padding: "5px" }}
              onClick={() => showRightSideBar(<RightSideBarContent2 />)}
            >
              Content 2
            </button>
            <button
              style={{ width: "120px", margin: "5px", padding: "5px" }}
              onClick={hideRightSideBar}
            >
              Hide
            </button>
          </div>
          <p>Theme</p>
          Press "ctrl+t"
          <p>Icons</p>
          <a href="https://fonts.google.com/icons" target="_blank">
            Material Icon Font
          </a>
          <br />
          <a href="https://www.untitledui.com/free-icons" target="_blank">
            Untitled UI Icons Test
          </a>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
          <p>Scroll</p>
        </div>
      </div>
    </div>
  );
}

export default Demo;
